<template>
    <div>
        ปลดล็อคถอนเงิน
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>